import { AlertService } from '../../../infrastructure/services/alert.service';
import { OnInit, Component } from '@angular/core';

@Component({
  selector: 'sx-alert',
  templateUrl: './alert.html'
})
export class AlertComponent implements OnInit {
  constructor(public alertService: AlertService) {}

  ngOnInit() {
    // this.alertService.alert.subscribe(alert => this.startDelayedClose());
  }

  public showSuccess(text: string) {
    // this.type = 'success';
    // this.text = text;
    // this.showAlert = true;
    this.startDelayedClose();
  }

  public showError(text: string) {
    // this.type = 'danger';
    // this.text = text;
    // this.showAlert = true;
    this.startDelayedClose();
  }

  public closeAlert() {
    // this.alertService.clearAlert();
  }

  private startDelayedClose() {
    setTimeout(() => {
        this.closeAlert();
    }, 5000);
  }
}

export interface IAlert {
  id: number;
  type: string;
  message: string;
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/sxAlert/alert.ts